import { render, staticRenderFns } from "./pwdlogin.vue?vue&type=template&id=217c4007&scoped=true&"
import script from "./pwdlogin.vue?vue&type=script&lang=js&"
export * from "./pwdlogin.vue?vue&type=script&lang=js&"
import style0 from "./pwdlogin.vue?vue&type=style&index=0&id=217c4007&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217c4007",
  null
  
)

export default component.exports